import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_BASE } from "../../constant";
import { isNull } from "lodash";
import { getSelectedTenant } from "../../utils/authToken";
import { RootStateOrAny, useSelector } from "react-redux";
import {
  Avatar,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  message,
  Modal,
  Row,
  Table,
  Upload,
} from "antd";
import "./Company.less";
import { MoreActionIcon } from "../../utils/icons";
import { useHistory } from "react-router-dom";
import {
  RcFile,
  UploadChangeParam,
  UploadFile,
  UploadProps,
} from "antd/lib/upload";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import api from "../../utils/api";

const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

const beforeUpload = (file: RcFile) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
};
function CompanyList() {
  const history = useHistory();
  const [form] = Form.useForm();
  const [companyList, setCompanyList] = useState<any>([]);
  const tenantId = getSelectedTenant();
  const { user } = useSelector((state: RootStateOrAny) => state.auth);
  const [openAddCompanyModal, setOpenAddCompanyModal] =
    useState<boolean>(false);

  useEffect(() => {
    axios
      .get(`${API_BASE}defaults/company-info/${tenantId}`, {
        headers: {
          Authorization: "Bearer " + user.accessToken,
          "tenant-id": !isNull(tenantId) ? tenantId : "",
        },
      })
      .then((response: any) => {
        console.log(response);
        setCompanyList(response.data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, []);

  const columns = [
    {
      title: "Company Name",
      dataIndex: "companyName",
      sorter: (a: any, b: any) => a?.companyName?.localeCompare(b?.companyName),
    },
    // {
    //   title: "Tenant Name",
    //   dataIndex: "tenantName",
    // },
    {
      title: "Street Address",
      dataIndex: "companyStreetAddressOne",
    },
    {
      title: "City",
      dataIndex: "companyCity",
      sorter: (a: any, b: any) => a?.companyCity?.localeCompare(b?.companyCity),
    },
    {
      title: "State",
      dataIndex: "companyStateProvince",
    },
    {
      title: "Email",
      dataIndex: "companyEmail",
    },
    {
      title: "Action",
      render: (data: any) => {
        return (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="edit"
                  style={{ fontWeight: "bold" }}
                  onClick={() => handleEdit(data)}
                >
                  Edit
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
          >
            <div>
              <MoreActionIcon />
            </div>
          </Dropdown>
        );
      },
    },
  ];

  const handleEdit = (data: any) => {
    console.log(data);
    history.push(`/admin-default-company-info/${data._id}`);
  };

  const handleCloseModal = () => {
    setOpenAddCompanyModal(false);
  };

  const checkEmpty = {
    validator(_: any, value: string) {
      if (value) {
        if (value.startsWith(" ")) {
          return Promise.reject(new Error("Invalid"));
        }
      }

      return Promise.resolve();
    },
  };

  const handleAddCompany = async (values: any) => {
    console.log(values);
    const companyBody = {
      ...values,
      tenant: tenantId,
      tenantName: values.companyName.replace(/\s/g, ''),
      franchiseNumber: '',
      companyLogo: ''
    }

    try {
      api.post('defaults/company-info', companyBody).then((resp: any) => {
        setCompanyList((prevCompanyList: any) => [...prevCompanyList, resp]);
        message.success("Company info is created");
        handleCloseModal();
      })

    } catch (err) {
      message.error("there is some issue with creating new company");
      console.error(`Error creating Company info: ${err}`);
    }
  };

  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>("");

  const handleChange: UploadProps["onChange"] = (
    info: UploadChangeParam<UploadFile>,
  ) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj as RcFile, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  const UploadButton = () => (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  return (
    <div className="company-root">
      <Row
        align="middle"
        style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "space-between",
          alignItems: "center",
        }}
      >
        <Col span={16}>
          <h1>Company List</h1>
        </Col>
        <Col
          span={8}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "20px",
          }}
        >
          <Button
            className="contractor-data-bulk-btn "
            onClick={() => {
              setOpenAddCompanyModal(true);
            }}
            style={{
              background: " #fdb913",
            }}
          >
            Add Company
          </Button>
        </Col>
      </Row>

      <hr style={{ border: "1px solid #E8E8E8", padding: 0, margin: 0 }} />
      {companyList.length && (
        <Table
          rowClassName={(_, index) =>
            index % 2 === 0
              ? "table_row table-row-light"
              : "table_row table-row-dark"
          }
          scroll={{ x: "900px" }}
          rowKey="_id"
          dataSource={companyList}
          columns={columns}
          loading={!companyList.length}
        />
      )}
      <Modal
        className="notes-modal-container"
        open={openAddCompanyModal}
        onCancel={() => setOpenAddCompanyModal(false)}
        title={
          <h1 style={{ marginTop: 10 }} className="send-title-text">
            Add Company
          </h1>
        }
        footer={false}
      >
        <Form
          form={form}
          onFinish={handleAddCompany}
          layout="vertical"
          scrollToFirstError
          autoComplete="off"
          style={{ padding: "24px" }}
        >
          <div>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Company Name</h3>

                  <Form.Item
                    name="companyName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={24}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Address</h3>

                  <Form.Item
                    name="companyStreetAddressOne"
                    // initialValue={address}
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={24}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Address 2</h3>

                  <Form.Item
                    name="companyStreetAddressTwo"
                    // initialValue={address}
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">City</h3>

                  <Form.Item
                    name="companyCity"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">State</h3>

                  <Form.Item
                    name="companyStateProvince"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Email</h3>

                  <Form.Item
                    name="companyEmail"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Phone Number</h3>

                  <Form.Item
                    name="officePhone"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Postal Code</h3>

                  <Form.Item
                    name="companyPostalCode"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>
              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Fax</h3>

                  <Form.Item
                    name="faxPhone"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Country</h3>

                  <Form.Item
                    name="companyCountry"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Proposal Number</h3>

                  <Form.Item
                    name="proposalNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Contractor License</h3>

                  <Form.Item
                    name="contractorLicense"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">State Registration</h3>

                  <Form.Item
                    name="stateRegistration"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Workers Comp</h3>

                  <Form.Item
                    name="workersComp"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>
              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Insurance</h3>

                  <Form.Item
                    name="insurance"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>
              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Source Id</h3>

                  <Form.Item
                    name="sourceId"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>
              <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Website Url</h3>

                  <Form.Item
                    name="companyWebsiteUrl"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>
              </Col>

              {/* <Col span={12}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Company Logo</h3>

                  <Form.Item
                    name="companyLogo"
                    rules={[
                      {
                        required: true,
                        message: "Please provide company logo!",
                      },
                    ]}
                  >
                    <Upload
                      name="avatar"
                      listType="picture-card"
                      className="avatar-upload"
                      action={`${API_BASE}defaults/company-info/upload-pic`}
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      onChange={handleChange}
                      accept="image/*"
                      headers={{
                        Authorization: `Bearer ${user.accessToken}`,
                        "tenant-id": tenantId ?? "",
                      }}
                    >
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt="Company logo preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <UploadButton />
                      )}
                    </Upload>
                  </Form.Item>
                </div>
              </Col> */}
            </Row>

            <Row justify="end" style={{ marginTop: 15 }}>
              <Col>
                <Button
                  key="back"
                  onClick={handleCloseModal}
                  className="cancel-btn"
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button
                  key="submit"
                  name="add"
                  type="primary"
                  className="send-btn"
                  htmlType="submit"
                >
                  Add
                </Button>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal>
    </div>
  );
}

export default CompanyList;
